import { Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/material/progress-spinner';
import * as ɵngcc3 from '@angular/material/progress-bar';

function MtxLoaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2);
} }
function MtxLoaderComponent_div_1_mat_spinner_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-spinner", 6);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("color", ctx_r2.color)("strokeWidth", ctx_r2.strokeWidth)("diameter", ctx_r2.diameter)("mode", ctx_r2.mode)("value", ctx_r2.value);
} }
function MtxLoaderComponent_div_1_mat_progress_bar_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "mat-progress-bar", 7);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("color", ctx_r3.color)("mode", ctx_r3.mode)("value", ctx_r3.value)("bufferValue", ctx_r3.bufferValue);
} }
function MtxLoaderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, MtxLoaderComponent_div_1_mat_spinner_1_Template, 1, 5, "mat-spinner", 4);
    ɵngcc0.ɵɵtemplate(2, MtxLoaderComponent_div_1_mat_progress_bar_2_Template, 1, 4, "mat-progress-bar", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.type === "spinner");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.type === "progressbar");
} }
const _c0 = ["*"];
class MtxLoaderComponent {
    constructor(_changeDetectorRef) {
        this._changeDetectorRef = _changeDetectorRef;
        this.type = 'spinner';
        this.loading = true;
        this.color = 'primary';
        this.mode = 'indeterminate';
        this.value = 0;
        this.strokeWidth = 4; // only support spinner
        this.diameter = 48; // only support spinner
        this.bufferValue = 0; // only support progresbar
        this.hasBackdrop = true;
    }
}
MtxLoaderComponent.ɵfac = function MtxLoaderComponent_Factory(t) { return new (t || MtxLoaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
MtxLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MtxLoaderComponent, selectors: [["mtx-loader"]], hostAttrs: [1, "mtx-loader"], hostVars: 2, hostBindings: function MtxLoaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mtx-loader-loading", ctx.loading);
    } }, inputs: { type: "type", loading: "loading", color: "color", mode: "mode", value: "value", strokeWidth: "strokeWidth", diameter: "diameter", bufferValue: "bufferValue", hasBackdrop: "hasBackdrop" }, exportAs: ["mtxLoader"], ngContentSelectors: _c0, decls: 3, vars: 2, consts: [["class", "mtx-loader-backdrop", 4, "ngIf"], ["class", "mtx-loader-main", 4, "ngIf"], [1, "mtx-loader-backdrop"], [1, "mtx-loader-main"], [3, "color", "strokeWidth", "diameter", "mode", "value", 4, "ngIf"], [3, "color", "mode", "value", "bufferValue", 4, "ngIf"], [3, "color", "strokeWidth", "diameter", "mode", "value"], [3, "color", "mode", "value", "bufferValue"]], template: function MtxLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, MtxLoaderComponent_div_0_Template, 1, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MtxLoaderComponent_div_1_Template, 3, 2, "div", 1);
        ɵngcc0.ɵɵprojection(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading && ctx.hasBackdrop);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.MatSpinner, ɵngcc3.MatProgressBar], styles: [".mtx-loader{position:relative;display:block;width:100%;height:100%}.mtx-loader-main{position:absolute;top:0;left:0;z-index:2;display:flex;justify-content:center;align-items:center;width:100%;height:100%}.mtx-loader-main .mat-spinner{position:relative}.mtx-loader-backdrop,.mtx-loader-main .mat-progress-bar{position:absolute;top:0;left:0;width:100%}.mtx-loader-backdrop{display:block;z-index:1;height:100%;content:\"\"}"], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
MtxLoaderComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
MtxLoaderComponent.propDecorators = {
    type: [{ type: Input }],
    loading: [{ type: Input }],
    color: [{ type: Input }],
    mode: [{ type: Input }],
    value: [{ type: Input }],
    strokeWidth: [{ type: Input }],
    diameter: [{ type: Input }],
    bufferValue: [{ type: Input }],
    hasBackdrop: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'mtx-loader',
                exportAs: 'mtxLoader',
                host: {
                    'class': 'mtx-loader',
                    '[class.mtx-loader-loading]': 'loading'
                },
                template: "<div class=\"mtx-loader-backdrop\" *ngIf=\"loading && hasBackdrop\"></div>\r\n<div class=\"mtx-loader-main\" *ngIf=\"loading\">\r\n  <mat-spinner *ngIf=\"type==='spinner'\"\r\n               [color]=\"color\"\r\n               [strokeWidth]=\"strokeWidth\"\r\n               [diameter]=\"diameter\"\r\n               [mode]=\"$any(mode)\"\r\n               [value]=\"value\">\r\n  </mat-spinner>\r\n\r\n  <mat-progress-bar *ngIf=\"type==='progressbar'\"\r\n                    [color]=\"color\"\r\n                    [mode]=\"$any(mode)\"\r\n                    [value]=\"value\"\r\n                    [bufferValue]=\"bufferValue\">\r\n  </mat-progress-bar>\r\n</div>\r\n<ng-content></ng-content>\r\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".mtx-loader{position:relative;display:block;width:100%;height:100%}.mtx-loader-main{position:absolute;top:0;left:0;z-index:2;display:flex;justify-content:center;align-items:center;width:100%;height:100%}.mtx-loader-main .mat-spinner{position:relative}.mtx-loader-backdrop,.mtx-loader-main .mat-progress-bar{position:absolute;top:0;left:0;width:100%}.mtx-loader-backdrop{display:block;z-index:1;height:100%;content:\"\"}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { type: [{
            type: Input
        }], loading: [{
            type: Input
        }], color: [{
            type: Input
        }], mode: [{
            type: Input
        }], value: [{
            type: Input
        }], strokeWidth: [{
            type: Input
        }], diameter: [{
            type: Input
        }], bufferValue: [{
            type: Input
        }], hasBackdrop: [{
            type: Input
        }] }); })();

class MtxLoaderModule {
}
MtxLoaderModule.ɵfac = function MtxLoaderModule_Factory(t) { return new (t || MtxLoaderModule)(); };
MtxLoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MtxLoaderModule });
MtxLoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, MatProgressSpinnerModule, MatProgressBarModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MtxLoaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, MatProgressSpinnerModule, MatProgressBarModule],
                exports: [MtxLoaderComponent],
                declarations: [MtxLoaderComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MtxLoaderModule, { declarations: function () { return [MtxLoaderComponent]; }, imports: function () { return [CommonModule, MatProgressSpinnerModule, MatProgressBarModule]; }, exports: function () { return [MtxLoaderComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MtxLoaderComponent, MtxLoaderModule };

//# sourceMappingURL=mtxLoader.js.map